import { useEffect } from 'react';
import { skipToken, useQuery } from '@apollo/client/react';

import {
    IGroupSelectorQueryVariables,
    GroupSelectorDocument,
} from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

export const useGroupSelectorList = (
    groupQueryVariables?: IGroupSelectorQueryVariables
) => {
    const { showApolloError } = useApolloError();

    const { data, loading, error } = useQuery(
        GroupSelectorDocument,
        groupQueryVariables
            ? {
                  variables: groupQueryVariables,
                  notifyOnNetworkStatusChange: true,
              }
            : skipToken
    );

    useEffect(() => {
        if (error) {
            showApolloError(error);
        }
    }, [error, showApolloError]);

    const groupsObject = data?.paginatedGroups;
    const groupsCount = groupsObject?.count;
    const groups =
        groupsObject?.edges.map((edge) => edge?.node || null).filter(Boolean) ||
        [];

    return {
        groups,
        groupsCount,
        loading,
    };
};
